<template>
  <b-dropdown
    :href="urls.users.settings(userId)"
    right
    dropup
    size="sm"
    variant="white"
    no-caret
  >
    <template #button-content>
      <i class="fa fa-fw fa-ellipsis-h"></i>
    </template>
    <b-dropdown-header>
      <i class="fa fa-fw fa-line-chart mr-1"></i>
      Business Plan
    </b-dropdown-header>
    <b-dropdown-item
      :href="urls.businessPlan.showTracker(userId)"
      target="_blank"
    >
      Tracker
    </b-dropdown-item>
    <b-dropdown-item
      :href="urls.businessPlan.showPlans(userId)"
      target="_blank"
    >
      Plans
    </b-dropdown-item>
    <b-dropdown-item
      :href="urls.businessPlan.showTasks('today', userId)"
      target="_blank"
    >
      Tasks
    </b-dropdown-item>
    <b-dropdown-item
      :href="urls.businessPlan.showPrepwork(userId)"
      target="_blank"
    >
      Prepwork
    </b-dropdown-item>
    <b-dropdown-item
      :href="urls.businessPlan.showEdit(userId)"
      target="_blank"
    >
      Edit Current Plan
    </b-dropdown-item>
    <b-dropdown-item
      :href="urls.businessPlan.createNextPlan(userId)"
      target="_blank"
    >
      Edit Next Plan
    </b-dropdown-item>
    <b-dropdown-divider></b-dropdown-divider>
    <b-dropdown-item
      :href="urls.sites.index(userId)"
      target="_blank"
    >
      Edit Website
    </b-dropdown-item>
    <b-dropdown-divider></b-dropdown-divider>
    <b-dropdown-header>
      <i class="fa fa-cog mr-1"></i>
      Settings
    </b-dropdown-header>
    <b-dropdown-item
      :href="urls.users.settings(userId)"
    >
      Edit Profile
    </b-dropdown-item>
    <b-dropdown-item
      :href="`/admin/resources/users/${userId}`"
    >
      Edit User
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
import urls from '@/api/urls'

export default {
  props: {
    userId: {
      type: [String, Number],
      required: true
    }
  },
  data () {
    return {
      urls
    }
  }
}
</script>
